import { equipmentAPI } from "api";

export const downloaddAPI = () => {
  let apiUrl = `/api/bulkupload/getinstrumentsbulkuploadtemplate`
  return equipmentAPI.get(apiUrl).then((res) => res);
}
